import axiosInstance from './axiosInstance';
import { baseUrl } from './Request';

// Renvoie la réponse HTTP même en erreur, comme CommuniqueRequest : les pages lisent response.status.
async function callWithToken(config) {
  try {
    return await axiosInstance({ ...config });
  } catch (error) {
    return error.response;
  }
}

export function verifyNewsletter(idNewsletter) {
  return callWithToken({ method: 'put', url: baseUrl + "newsletters/" + idNewsletter + "/verify", data: {} });
}

export function sendNewsletter(idNewsletter) {
  return callWithToken({ method: 'post', url: baseUrl + "newsletters/" + idNewsletter + "/send", data: {} });
}

export function getAbonneesForNewsletter(idNewsletter, page = 0, size = 8, search = '') {
  let url = baseUrl + "newsletters/" + idNewsletter + "/abonnees?page=" + page + "&size=" + size;
  if (search) url += "&search=" + encodeURIComponent(search);
  return callWithToken({ method: 'get', url });
}

export const NEWSLETTER_ENVOI_API = {
  verify: verifyNewsletter,
  send: sendNewsletter,
  getAbonnees: getAbonneesForNewsletter,
};

// Liste admin paginée côté serveur ; data = lignes, chacune commençant par sa version principale.
export function listNewslettersPagines(page, limit, { titre, date, idlanguage }, isGroupe) {
  const params = new URLSearchParams({ page, limit, grouper: isGroupe });
  if (titre) params.append('titre', titre);
  if (date) params.append('date', date);
  if (idlanguage) params.append('lang', idlanguage);
  return callWithToken({ method: 'get', url: baseUrl + "newsletters/pagination?" + params });
}
